












import Company from "@/models/company";
import CompanyAPI from "@/services/companies";
import { LayoutModule } from "@/store/layout";
import { Component, Vue } from "vue-property-decorator";
import CompanyForm from "./Components/CompanyForm.vue";

@Component({
  components: { CompanyForm },
})
export default class EditCompany extends Vue {
  company: Company | null = null;
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getCompany();
  }

  async save(company: Company): Promise<void> {
    LayoutModule.showLoader();
    try {
      await CompanyAPI.updateCompany(company);
      LayoutModule.setAlerts({
        text: this.$t("companies.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "companies" });
  }

  async getCompany(): Promise<void> {
    LayoutModule.showLoader();

    try {
      const r = await CompanyAPI.getCompany(this.$route.params.id);
      this.company = r;
    } catch (e) {
      console.log(e);
    } finally {
      LayoutModule.hideLoader();
    }
    this.loading = false;
  }
}
